import React from "react";

export const Space = () => {
  return <span className="flex-grow"></span>;
};
